enum HeaderVariant {
    DEFAULT = 'default',
    SECTION = 'section',
}

export default HeaderVariant;
